// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setting-section .sub-block-head {
  text-align: center;
  margin-bottom: 0.5rem;
}
.setting-section .plan-wrapper {
  max-width: 960px;
  margin: auto;
  display: flex;
  gap: 15px;
}
.setting-section .list-group {
  width: 600px;
}
.setting-section .list-group .list-group-item {
  background: #fcfafa;
  font-size: 0.9rem !important;
}
.setting-section a.upgrade-btn {
  color: hsl(217, 71%, 53%) !important;
  font-weight: bold;
}
.setting-section .card.box-overflow {
  height: calc(100vh - 100px);
}
.setting-section .card-body {
  padding: 1rem !important;
}
.setting-section ::ng-deep .field.StripeElement {
  border-color: hsl(0, 0%, 80%) !important;
  border-width: 1px;
  border-style: solid;
  border-radius: 5px;
  height: 2.5em !important;
  padding-top: 8px;
}
.setting-section ::ng-deep .field.StripeElement .ElementsApp input {
  height: 2.5em !important;
}
.setting-section .settingsCard-header .main-heading {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  width: 100%;
}
.setting-section .settingsCard-header .main-heading .second {
  width: auto;
}

table th,
table td {
  max-width: 300px;
  padding: 8px 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table tbody tr:hover td {
  background: var(--table-hover-bg) !important;
}

table thead {
  position: sticky;
  inset-block-start: 0;
}

table thead th {
  padding: 10px 3px;
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f4f4f4;
  color: #111;
}

@media screen and (max-width: 767px) {
  .plan-wrapper {
    display: block !important;
  }
  .tabs {
    display: block !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/subscription/subscription.component.scss"],"names":[],"mappings":"AAEI;EACI,kBAAA;EACA,qBAAA;AADR;AAGI;EACI,gBAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;AADR;AAGI;EACI,YAAA;AADR;AAEQ;EACI,mBAAA;EACA,4BAAA;AAAZ;AAGI;EACI,oCAAA;EACA,iBAAA;AADR;AAGI;EACI,2BAAA;AADR;AAII;EACI,wBAAA;AAFR;AAII;EACI,wCAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;AAFR;AAGQ;EACI,wBAAA;AADZ;AAKQ;EACI,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,WAAA;AAHZ;AAIY;EACI,WAAA;AAFhB;;AAQA;;EAEE,gBAAA;EACA,iBAAA;EAEA,gBAAA;EACA,uBAAA;EACA,mBAAA;AANF;;AASA;EACE,4CAAA;AANF;;AAQA;EACE,gBAAA;EACA,oBAAA;AALF;;AAQC;EACG,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;EACA,WAAA;AALJ;;AAQA;EACI;IACI,yBAAA;EALN;EAOE;IACI,yBAAA;EALN;AACF","sourcesContent":[".setting-section{\n\n    .sub-block-head{\n        text-align: center;\n        margin-bottom:.5rem;\n    }\n    .plan-wrapper{\n        max-width:960px;\n        margin: auto;\n        display: flex;\n        gap:15px;\n    }\n    .list-group{\n        width:600px;\n        .list-group-item{\n            background:#fcfafa;\n            font-size:.9rem !important;\n        }\n    }\n    a.upgrade-btn{\n        color:hsl(217, 71%, 53%) !important;\n        font-weight: bold;\n    }\n    .card.box-overflow{\n        height:calc(100vh - 100px);\n    }\n\n    .card-body{\n        padding:1rem !important;\n    }\n    ::ng-deep .field.StripeElement{\n        border-color: hsl(0, 0%, 80%) !important;\n        border-width:1px;\n        border-style: solid;\n        border-radius:5px;\n        height:2.5em !important;\n        padding-top: 8px;\n        .ElementsApp input{\n            height:2.5em !important;\n        }\n    }\n    .settingsCard-header{\n        .main-heading{\n            display: flex;\n            justify-content: space-between;\n            font-weight: bold;\n            width:100%;\n            .second{\n                width:auto;\n            }\n        }\n    }\n}\n\ntable th,\ntable td {\n  max-width: 300px;\n  padding: 8px 16px;\n \n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.table tbody tr:hover td{\n  background:var(--table-hover-bg) !important;\n}\ntable thead {\n  position: sticky;\n  inset-block-start: 0;\n \n}\n table thead th {\n    padding:10px 3px;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    background: #f4f4f4;\n    color: #111;\n  }\n\n@media screen and (max-width:767px) {\n    .plan-wrapper{\n        display: block !important;\n    }\n    .tabs{\n        display: block !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
